import Scrollzone from './Scrollzone'

export default Scrollzone
